<template>
    <div class="menu">
        <MenuCategoryHeading 
            :title="category.name" 
            :description="category.description"
            :image="category.image"
            data-aos="fade-up" 
        />
        <MenuCategoryDetail 
            :dishes="dishes" 
            data-aos="fade-left" 
            data-aos-delay="500" 
        />
    </div>
</template>

<script>
import MenuCategoryHeading from '@/components/menu/MenuCategoryHeading'
import MenuCategoryDetail from '@/components/menu/MenuCategoryDetail'
export default {
    components: {
        MenuCategoryHeading,
        MenuCategoryDetail
    },
    props: ['category', 'dishes']
}
</script>

<style lang="scss" scoped>
    .menu {
        display: flex;
    }
</style>
